import { Dimensions } from "@faire/slate/foundation/dimensions";
import { SVGIconProps } from "@faire/slate-icons/types";
import React from "react";

type IProps = {
  Icon: React.FC<SVGIconProps>;
};

export const FilterIcon: React.FC<IProps> = ({ Icon }) => (
  <div className="fs-filter__icon">
    <Icon
      aria-hidden
      color="inherit"
      fontSize={Dimensions[4]}
      role="presentation"
      titleAccess={undefined}
    />
  </div>
);
